import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Modal,
    Button,
    Row,
    Col,
    Form,
} from "react-bootstrap";
import validate from "validate.js";
import {
    createOrUpdateCategory,
    hideCategoryValidationError,
    getCategoryById,
    timeSheetCategoryRedirectToList
} from "actions";

const schema = {
    name: {
        presence: { allowEmpty: false, message: '^Category name is required' },
    },
};

const AddUpdateCategories = (props) => {
    const {
        show,
        onHide,
        isEdit = false,
        object_viewed_id,
    } = props;

    const dispatch = useDispatch();
    const timeSheetCategoryState = useSelector((state) => state.timeSheetCategoryState);
    const { categoryRecord, validation_error, redirectToList } = timeSheetCategoryState;

    const [formState, setFormState] = useState({
        isValid: false,
        values: {},
        touched: {},
        errors: {}
    });

    useEffect(() => {
        if (isEdit && categoryRecord) {
            setFormState(formState => ({
                ...formState,
                values: {
                    id: categoryRecord.id,
                    name: categoryRecord.name,
                    description: categoryRecord.description,
                }
            }));
        }
    }, [categoryRecord, isEdit]);

    useEffect(() => {
        if (validation_error) {
            setFormState((formState) => ({
                ...formState,
                isValid: false,
                errors: validation_error || {},
            }));
        }
    }, [validation_error]);

    useEffect(() => {
        const errors = validate(formState.values, schema);
        setFormState(formState => ({
            ...formState,
            isValid: !errors,
            errors: errors || {}
        }));
    }, [formState.values]);

    useEffect(() => {
        if (redirectToList) {
            onHide();
        }
    }, [redirectToList, onHide]);

    const handleChange = (event) => {
        event.persist();
        setFormState((formState) => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]: event.target.value,
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true,
            },
        }));
        dispatch(hideCategoryValidationError(event.target.name));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const method = formState.values.id ? "PUT" : "POST";
        dispatch(createOrUpdateCategory({ ...formState.values, object_viewed_id }, method));
    };

    const hasError = (field) =>
        formState.touched[field] && formState.errors[field] ? true : false;

    const onModelClose = () => {
        onHide();
        dispatch(timeSheetCategoryRedirectToList());
    }

    return (
        <Modal
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="p-4"
            onHide={onModelClose}
        >
            <div className="p-2">
                <Modal.Header closeButton className="p-2">
                    <Modal.Title >
                        <h5 className="font-20 font-weight-bold heading-color">{isEdit ? "Update" : "Add"} Category</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="align-items-center">
                            <Col lg={12}>
                                <Form.Group>
                                    <Form.Label className="font-13 font-weight-400 page-heading">
                                        Name
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter name"
                                        name='name'
                                        onChange={handleChange}
                                        value={formState.values.name || ''}
                                        className={`input-field ${hasError('name') ? 'is-invalid' : ''}`}
                                    />
                                    {hasError('name') && (
                                        <Form.Control.Feedback type="invalid">
                                            {formState.errors.name[0]}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label className="label-input">Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                style={{
                                borderRadius: "10px",
                                border: "1px solid rgb(206, 212, 218)",
                                padding: "4px 12px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "rgb(97, 121, 115)"
                                }}
                                onChange={handleChange}
                                value={formState.values.description || ''}
                                name='description'
                                placeholder="Type here"
                            />
                            {hasError('description') && (
                                <Form.Control.Feedback type="invalid">
                                    {formState.errors.description[0]}
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>

                        <Row className="mt-3">
                            <Col lg={6}>
                                <button
                                    type="button"
                                    className="c-b-btn w-100"
                                    onClick={onModelClose}
                                >
                                    Cancel
                                </button>
                            </Col>
                            <Col lg={6}>
                                <button
                                    type="button"
                                    className="n-u-btn w-100"
                                    onClick={handleSubmit}
                                    disabled={!formState.isValid}
                                >
                                    {isEdit ? "Update" : "Add"}
                                </button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default AddUpdateCategories;
